import { useState, useEffect } from 'react';

var useScroll = function useScroll() {
  var _a = useState({
    scrollX: 0,
    scrollY: 0
  }),
      scroll = _a[0],
      setScroll = _a[1];

  useEffect(function () {
    window.addEventListener('scroll', scrollHandler);
    return function () {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  var scrollHandler = function scrollHandler() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    var scrollX = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    var scrollY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    setScroll({
      scrollX: scrollX,
      scrollY: scrollY
    });
  };

  return scroll;
};

export default useScroll;